<style scoped>
#page-topbar{
  background-color: #ffffff!important;
  box-shadow: none!important;
  border-bottom:solid 1px #b1b1b142!important;
}
.noti-icon i{
  color: #7e7e7e!important;
}
body[data-topbar=dark] .header-item{
  color: #7e7e7e!important;
}
.header-profile-user{
  color: #7e7e7e!important;
  background-color:#7e7e7e!important;
}
#balanceSection{
  border-bottom:solid 4px rgba(255, 0, 0, 0.5)!important;
}

</style>
<script>
import {  mapGetters } from "vuex";

export default {
  data(){
    return {
      form:{},
      src: ''
    }
  },
  computed: {
      ...mapGetters('authfack',['userdata','balance'])
  },
  methods: {
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    close(){
      this.$parent.$bvModal.hide('pay-modal')
    },
    open(){
    
      const token = localStorage.getItem('token')
   
      let url = this.$http.defaults.baseURL
      if (url.endsWith("/api")) {
          url = url.replace(/\/api$/, '');
      }
      this.src = url + '/Payment/'  + '?token=' +token  + '&balance=' + this.balance
      this.$parent.$bvModal.show('pay-modal')
      
    },
  },
 
};
</script>

<template>
 <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt  />
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light">
            <span class="logo-lg">
              <img src="@/assets/images/logo-light.png" alt  />
            </span>
          </router-link>
        </div>
        <button
          id="toggle"
          type="button"
          class="btn btn-sm me-2 font-size-16 d-lg-none header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>

      <div class="d-flex">
        <div class="dropdown d-none d-lg-inline-block ms-1 border-right">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>
        <div class="dropdown d-none d-lg-inline-block ms-1 border" v-if="userdata.currentUser.role_name == 'dealer'" >
          <button
            id="balanceSection"
            type="button"
            class="btn header-item noti-icon"
            @click="open"
          >
           Bakiye <br> {{ $paraFormat(balance) }}
          </button>
        </div>
      
        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user"
              src="@/assets/images/users/avatar-1.jpg"
              alt="Header Avatar"
            />
            <span class="d-none d-xl-inline-block ms-1" style="color:#1a1a1a">{{ userdata.currentUser.name }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block" style="color:#1a1a1a"></i>
          </template>
          <!-- item-->
          <b-dropdown-item>
            <router-link tag="span" to="/ayarlar/panel-ayarlari">
              <i class="bx bx-user font-size-16 align-middle me-1"></i>
              Panel Ayarları
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item href="javascript: void(0);">
            <router-link tag="span" to="/extre-raporu">
              <i class="bx bx-wallet font-size-16 align-middle me-1"></i>
              Extre Hareketleri
            </router-link>
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <a href="/logout" class="dropdown-item text-danger">
            <i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
            {{ $t("navbar.dropdown.henry.list.logout") }}
          </a>
        </b-dropdown>
      </div>
    </div>
    <b-modal id="pay-modal" title="Ödeme Yap"  no-close-on-backdrop hide-footer>
      <iframe :src="src" width="100%" height="600px"/>
    </b-modal>
  </header>
</template>
